import { Button, Grid, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom";


export interface UnauthProps {
  message?: string;
};

export const Unauth = (props: UnauthProps) => {
  const navigate = useNavigate();

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={(theme) => ({
        backgroundColor: theme.palette.background.default,
        minHeight: '100vh', // fill the entire screen height
      })}
      spacing={2}
    >
      <Typography color="textPrimary" variant="h5" gutterBottom>
        Oops, something went wrong. 😞
      </Typography>
      <Typography color="textPrimary">
        {props.message ?? "Unable to authorize access for this resource"}
      </Typography>
      <Button
        onClick={async() => {
          localStorage.removeItem("jwt");
          await navigate("/login");
        }}
      >Log me out Scotty!</Button>
    </Grid>
  )
}